function updateImage(el, binding) {
	let device = binding.value.device;
	let urlImageToUse = binding.value.images[device];
	let isImage = el.tagName.toLowerCase() === 'img';
	let curUrlImage = null;

	if (isImage) {
        curUrlImage = el.src;
	} else {
        curUrlImage = window.getComputedStyle(el).getPropertyValue('background-image');
		curUrlImage = /^url\((['"]?)(.*)\1\)$/.exec(curUrlImage);
		curUrlImage = curUrlImage ? curUrlImage[2] : '';
	}

	// If different image and not empty
	if (
		urlImageToUse &&
		urlImageToUse !== curUrlImage &&
		curUrlImage !== null
	) {
		// If element is img
		if (isImage) {
            el.src = urlImageToUse;
		} else {
            el.style.backgroundImage = 'url(' + urlImageToUse + ')';
		}
	}
}

const vImgResponsive = {
	beforeMount(el) {},

	mounted(el, binding) {
		if (binding.value.device !== null) {
			updateImage(el, binding);
		}
	},

	updated(el, binding) {
		let device = binding.value.device;
		let oldDevice = binding.oldValue.device;

		if (device !== null && device !== oldDevice) {
			updateImage(el, binding);
		}
	},

	unmounted(el, binding) {},
};

export default vImgResponsive;